// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"881":"cdf2f319","3251":"9b79cbba","3616":"cdf2f319","5229":"cdf2f319","5491":"cdf2f319","6985":"cdf2f319","8488":"86454a2c"}[chunkId] + ".chunk.css";
};